<template>
    <console-layout width="100%" max-width="1280">

        <console-title>
            <span>단체 메일발송</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row align="center">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[0]" label="가입일자" persistent-placeholder hide-details />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[1]" label="가입일자" persistent-placeholder hide-details />
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" label="검색조건" persistent-placeholder hide-details :items="searchKeys" item-text="text" item-value="value" @input="filter.searchValue = null;"/>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page=1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>

            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span>
                </span>
            </v-layout>
    
            <v-data-table :items="members" :headers="membersHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template slot="item.no" slot-scope="{item}">
                    <span>{{ (page - 1) * limit + +members.indexOf(item) + 1 }}</span>
                </template>
                <template slot="item.createdAt" slot-scope="{item}">
                    <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</span>
                </template>
                <template slot="item.emailEnabled" slot-scope="{item}">
                    <span>{{ item.emailEnabled ? "Y" : "N" }}</span>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>
            <v-expand-transition>
                <v-card class="mt-4" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2 font-weight-bold pb-2">메일 수신</v-card-title>
                    <v-card-text>
                        <v-radio-group v-model="mail.isEmailEnabled" row dense hide-details class="pa-0 ma-0">
                            <v-layout align-center wrap>
                                <v-flex grow-shrink-0>
                                    <v-radio label="수신거부회원 포함" value="all" />
                                </v-flex>
                                <v-flex grow-shrink-0>
                                    <v-radio label="수신거부회원 제외" value="except" />
                                </v-flex>
                            </v-layout>
                        </v-radio-group>
                    </v-card-text>
                </v-card>
            </v-expand-transition>
    
            <v-expand-transition>
                <v-card class="mt-4" :disabled="!$hasScope(['root', 'admin'])">
                    <v-card-title class="subtitle-2 font-weight-bold">메일 정보</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="mail.subject" label="제목" persistent-placeholder hide-details class="mt-3"></v-text-field>
                    </v-card-text>
                    <v-card-text>
                        <naver-smarteditor v-model="mail.content"/>
                    </v-card-text>
                </v-card>
            </v-expand-transition>
    
            <v-row class="my-6">
                <v-spacer/>
                <v-col cols="auto" class="py-0">
                    <v-btn :loading="loading" :disabled="loading || !$hasScope(['root', 'admin'])" color="primary" @click="send">
                        발송하기
                        <template v-slot:loader>
                            <v-progress-circular indeterminate></v-progress-circular>
                        </template>
                    </v-btn>
                </v-col>
                <v-spacer/>
            </v-row>
        </console-body>

        

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        VDateField,
        NaverSmarteditor
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                isWithdrawal: false,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            members: [],
            membersHeaders: [
                { text: "no", value: "no", align: "center", width: 50 },
                { text: "이름", value: "name", align: "center", width: 100 },
                { text: "아이디", value: "username", align: "center", width: 100 },
                { text: "휴대폰", value: "phone", align: "center", width: 150 },
                { text: "이메일", value: "email", align: "center", width: 200 },
                { text: "방문수", value: "visitedCount", align: "center", width: 100 },
                { text: "메일수신", value: "emailEnabled", align: "center", width: 100 },
                { text: "가입일", value: "createdAt", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "아이디", value: "username" },
            ],

            mail: {
                subject: null,
                isEmailEnabled: "all",
                content: null
            },

            loading: false
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        validate() {
            try {
                if(!this.mail.subject) throw new Error("제목을 입력해주세요");
                if(!this.mail.isEmailEnabled) throw new Error("메일 수신방법을 선택해주세요");
                if(!this.mail.content) throw new Error("내용을 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }
            let { summary, members } = await api.console.members.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });
            this.members = members;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        async send() {
            if(this.validate()) {
                if(confirm("단체 메일을 발송하시겠습니까?")) {
                    this.mail = {
                        ...this.mail,
                        ...this.filter
                    }
                    this.loading = true;
                    let { success, count } = await api.console.common.emails.post(this.mail);
                    if(success) {
                        this.loading = false;
                        alert(`${count.format()}명의 회원에게 메일이 발송되었습니다`)
                    }
                }
            }
        }
    }
}
</script>